module.exports = __webpack_public_path__ + "img/ssh.74104a58.svg";